// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_j5-0";
export var animationContainer = "_j5-1";
export var itemPrice = "_j5-a";
export var itemizedContent = "_j5-9";
export var itemizedHeader = "_j5-7";
export var itemizedRow = "_j5-8";
export var itemizedSection = "_j5-6";
export var modalContent = "_j5-2";
export var orderName = "_j5-3";
export var refundOption = "_j5-4";
export var refundOptionsContainer = "_j5-5";
export var shippingLabel = "_j5-b";
export var totalRow = "_j5-c";